// extracted by mini-css-extract-plugin
export default {"genericAccordion":"GenericAccordion_genericAccordion__6ZAtL"};